<div class="modal-body m-3 text-center">
    <fa-icon class="mx-3" size="2x" [icon]="faCloudArrowDown"></fa-icon>
    <p>Downloading File:</p>
    <p style="font-weight: 700;">{{ downloadingFile.name }}</p>
    <div class="spinner-grow pt-3" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>

    @if (errorResponse) {
    <div class="alert alert-danger text-center" role="alert">
        {{ errorResponse.error.error_description || 'Errore Download File!' }}
    </div>
    }
</div>